module.exports = __webpack_public_path__ + "static/media/city_driver.403249a8.svg";